/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplePushNotificationDeviceTokenEntity } from '../models/ApplePushNotificationDeviceTokenEntity';
import type { FcmPushNotificationDeviceTokenEntity } from '../models/FcmPushNotificationDeviceTokenEntity';
import type { NotificationEntity } from '../models/NotificationEntity';
import type { OrganizationUserNotificationPreferencesEntity } from '../models/OrganizationUserNotificationPreferencesEntity';
import type { RegisterPushDeviceTokenDto } from '../models/RegisterPushDeviceTokenDto';
import type { UpdateNotificationsToReadDto } from '../models/UpdateNotificationsToReadDto';
import type { UpdateOrganizationUserNotificationPreferencesDto } from '../models/UpdateOrganizationUserNotificationPreferencesDto';
import type { UpdatePushDeviceDeactivatedDto } from '../models/UpdatePushDeviceDeactivatedDto';
import type { UpdateUserCommunicationPreferencesDto } from '../models/UpdateUserCommunicationPreferencesDto';
import type { UpdateUserNotificationPreferencesDto } from '../models/UpdateUserNotificationPreferencesDto';
import type { UserCommunicationPreferencesEntity } from '../models/UserCommunicationPreferencesEntity';
import type { UserNotificationPreferencesEntity } from '../models/UserNotificationPreferencesEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all notifications
     * @returns NotificationEntity The Notifications have been returned
     * @throws ApiError
     */
    public notificationControllerGetNotificationsV1(): CancelablePromise<Array<NotificationEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification',
        });
    }
    /**
     * Update Notifications to read
     * @param requestBody
     * @returns NotificationEntity The Notifications have been updated and returned
     * @throws ApiError
     */
    public notificationControllerSetNotificationsToReadV1(
        requestBody: UpdateNotificationsToReadDto,
    ): CancelablePromise<Array<NotificationEntity>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/notification/read',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the UserCommunicationPreferences
     * @returns UserCommunicationPreferencesEntity The UserCommunicationPreferences have been returned
     * @throws ApiError
     */
    public notificationControllerGetUserCommunicationPreferencesV1(): CancelablePromise<UserCommunicationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification/userCommunicationPreferences',
        });
    }
    /**
     * Update the UserCommunicationPreferences
     * @param requestBody
     * @returns UserCommunicationPreferencesEntity UserCommunicationPreferences have been updated
     * @throws ApiError
     */
    public notificationControllerUpdateUserCommunicationPreferencesV1(
        requestBody: UpdateUserCommunicationPreferencesDto,
    ): CancelablePromise<UserCommunicationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/notification/userCommunicationPreferences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List APN device registrations (token values are omitted)
     * @returns ApplePushNotificationDeviceTokenEntity ApplePushNotificationDeviceToken rows without deviceToken
     * @throws ApiError
     */
    public notificationControllerGetApplePushNotificationDeviceTokensV1(): CancelablePromise<Array<ApplePushNotificationDeviceTokenEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification/userCommunicationPreferences/apnDeviceToken',
        });
    }
    /**
     * Add an APN device token to the UserCommunicationPreferences
     * @param requestBody
     * @returns ApplePushNotificationDeviceTokenEntity ApplePushNotificationDeviceToken has been created
     * @throws ApiError
     */
    public notificationControllerAddApplePushNotificationDeviceTokenV1(
        requestBody: RegisterPushDeviceTokenDto,
    ): CancelablePromise<ApplePushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/notification/userCommunicationPreferences/apnDeviceToken',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List FCM device registrations (token values are omitted)
     * @returns FcmPushNotificationDeviceTokenEntity FcmPushNotificationDeviceToken rows without deviceToken
     * @throws ApiError
     */
    public notificationControllerGetFcmPushNotificationDeviceTokensV1(): CancelablePromise<Array<FcmPushNotificationDeviceTokenEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification/userCommunicationPreferences/fcmDeviceToken',
        });
    }
    /**
     * Add an FCM device token to the UserCommunicationPreferences
     * @param requestBody
     * @returns FcmPushNotificationDeviceTokenEntity FcmPushNotificationDeviceToken has been created
     * @throws ApiError
     */
    public notificationControllerAddFcmPushNotificationDeviceTokenV1(
        requestBody: RegisterPushDeviceTokenDto,
    ): CancelablePromise<FcmPushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/notification/userCommunicationPreferences/fcmDeviceToken',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove an APN device registration by installationId
     * @param installationId Stable client installation id (same value used when registering the token)
     * @returns ApplePushNotificationDeviceTokenEntity ApplePushNotificationDeviceToken has been removed
     * @throws ApiError
     */
    public notificationControllerDeleteApplePushNotificationDeviceTokenByInstallationIdV1(
        installationId: string,
    ): CancelablePromise<ApplePushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/notification/userCommunicationPreferences/apnDeviceToken/installation/{installationId}',
            path: {
                'installationId': installationId,
            },
        });
    }
    /**
     * Remove an APN device registration by id
     * @param deviceId ApplePushNotificationDevice id
     * @returns ApplePushNotificationDeviceTokenEntity ApplePushNotificationDeviceToken has been removed
     * @throws ApiError
     */
    public notificationControllerDeleteApplePushNotificationDeviceTokenV1(
        deviceId: string,
    ): CancelablePromise<ApplePushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/notification/userCommunicationPreferences/apnDeviceToken/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * Set whether an APN device registration is deactivated
     * @param deviceId ApplePushNotificationDevice id
     * @param requestBody
     * @returns ApplePushNotificationDeviceTokenEntity ApplePushNotificationDeviceToken has been updated
     * @throws ApiError
     */
    public notificationControllerUpdateApplePushNotificationDeviceDeactivatedV1(
        deviceId: string,
        requestBody: UpdatePushDeviceDeactivatedDto,
    ): CancelablePromise<ApplePushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/notification/userCommunicationPreferences/apnDeviceToken/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove an FCM device registration by installationId
     * @param installationId Stable client installation id (same value used when registering the token)
     * @returns FcmPushNotificationDeviceTokenEntity FcmPushNotificationDeviceToken has been removed
     * @throws ApiError
     */
    public notificationControllerDeleteFcmPushNotificationDeviceTokenByInstallationIdV1(
        installationId: string,
    ): CancelablePromise<FcmPushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/notification/userCommunicationPreferences/fcmDeviceToken/installation/{installationId}',
            path: {
                'installationId': installationId,
            },
        });
    }
    /**
     * Remove an FCM device registration by id
     * @param deviceId FcmPushNotificationDevice id
     * @returns FcmPushNotificationDeviceTokenEntity FcmPushNotificationDeviceToken has been removed
     * @throws ApiError
     */
    public notificationControllerDeleteFcmPushNotificationDeviceTokenV1(
        deviceId: string,
    ): CancelablePromise<FcmPushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/notification/userCommunicationPreferences/fcmDeviceToken/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * Set whether an FCM device registration is deactivated
     * @param deviceId FcmPushNotificationDevice id
     * @param requestBody
     * @returns FcmPushNotificationDeviceTokenEntity FcmPushNotificationDeviceToken has been updated
     * @throws ApiError
     */
    public notificationControllerUpdateFcmPushNotificationDeviceDeactivatedV1(
        deviceId: string,
        requestBody: UpdatePushDeviceDeactivatedDto,
    ): CancelablePromise<FcmPushNotificationDeviceTokenEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/notification/userCommunicationPreferences/fcmDeviceToken/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the UserNotificationPreferences
     * @returns UserNotificationPreferencesEntity The UserNotificationPreferences have been returned
     * @throws ApiError
     */
    public notificationControllerGetUserNotificationPreferencesV1(): CancelablePromise<UserNotificationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification/userNotificationPreferences',
        });
    }
    /**
     * Update the userNotificationPreferences
     * @param requestBody
     * @returns UserNotificationPreferencesEntity userNotificationPreferences have been updated
     * @throws ApiError
     */
    public notificationControllerUpdateUserNotificationPreferencesV1(
        requestBody: UpdateUserNotificationPreferencesDto,
    ): CancelablePromise<UserNotificationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/notification/userNotificationPreferences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the OrganizationUserNotificationPreferences
     * @param organizationId
     * @returns OrganizationUserNotificationPreferencesEntity The OrganizationUserNotificationPreferences have been returned
     * @throws ApiError
     */
    public notificationControllerGetOrganizationUserNotificationPreferencesV1(
        organizationId: string,
    ): CancelablePromise<OrganizationUserNotificationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/notification/OrganizationUserNotificationPreferences',
            query: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Update the OrganizationUserNotificationPreferences for an Organization
     * @param organizationId
     * @param requestBody
     * @returns OrganizationUserNotificationPreferencesEntity OrganizationUserNotificationPreferences has been updated
     * @throws ApiError
     */
    public notificationControllerUpdateOrganizationUserNotificationPreferencesV1(
        organizationId: string,
        requestBody: UpdateOrganizationUserNotificationPreferencesDto,
    ): CancelablePromise<OrganizationUserNotificationPreferencesEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/notification/OrganizationUserNotificationPreferences',
            query: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
